import { TitleCasePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { LoginService } from "src/app/core/services/login.service";
import { ToastNotificationService } from "src/app/core/services/toast-notification.service";
import { ConfirmedValidators } from "src/app/_helpers/confirmed.validators";

@Component({
  selector: "app-forgot-password",
  templateUrl: "./forgot-password.component.html",
  styleUrls: ["./forgot-password.component.scss"],
})
export class ForgotPasswordComponent implements OnInit {
  showNewPassword = false;
  showConfirmPassword = false;
  forgetPassForm: any;
  verifyPasswordFrom: FormGroup;
  public submitted: boolean;
  verifyShow: boolean = false;
  config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: "",
    inputStyles: {
      width: "40px",
      height: "40px",
      "font-size": "20px",
    },
  };
  constructor(
    private formBuilder: FormBuilder,
    private toastService: ToastNotificationService,
    private loginService: LoginService,
    private router: Router,
    private titleCasePipe: TitleCasePipe
  ) {}

  ngOnInit(): void {
    this.forgetPassForm = this.formBuilder.group({
      forgetpass: ["", [Validators.required, Validators.email,Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$")]],
    });
    this.verifyPasswordFrom = this.formBuilder.group(
      {
        email: ["", [Validators.required, Validators.email ,Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$")]],
        otp: [null, [Validators.required, Validators.minLength(6)]],
        newPassword: ["", [Validators.required]],
        confirmPassword: ["", [Validators.required]],
      },

      {
        validator: ConfirmedValidators("newPassword", "confirmPassword"),
      }
    );
  }
  get f() {
    return this.forgetPassForm.controls;
  }
  toggleNewPasswordVisibility(): void {
    this.showNewPassword = !this.showNewPassword;
  }

  toggleConfirmPasswordVisibility(): void {
    this.showConfirmPassword = !this.showConfirmPassword;
  }
  get verifyPasswordFromControl() {
    return this.verifyPasswordFrom.controls;
  }
  onOtpChange(a) {
    console.log("onOtpChange", a);
    this.verifyPasswordFrom.get("otp").patchValue(a);
  }
  postforgotpassword() {
    this.submitted = true;
    if (this.forgetPassForm.invalid) {
      console.log("postforgotpassword", this.submitted);
      return false;
    } else {
      let body = {
        email: this.forgetPassForm.controls.forgetpass.value,
      };
      this.verifyPasswordFrom.get("email").patchValue(body.email);
      this.loginService.forgotpassword(body).then(
        (res) => {
          this.toastService.toastMsg({
            title: "Success",
            content: "OTP Has Been Successfully Sent To Your Email Address!",
          });
          // this.toastService.openSnackBar(
          //   "OTP Has Been Successfully Sent To Your Email Address"
          // );
          this.verifyShow = true;
          // this.router.navigate(["/auth/verify-password"]);
        },
        (err) => {
          if (err.error.expose) {
            this.toastService.toastMsg({
              title: "Error",
              content:  this.titleCasePipe.transform(err.error.error_message),
            });
            // this.toastService.openErrorSnackBar(
            //   this.titleCasePipe.transform(err.error.error_message)
            // );
          } else {
            this.toastService.toastMsg({
              title: "Error",
              content: "Something Went Wrong.",
            });
            // this.toastService.openErrorSnackBar("Something Went Wrong.");
          }
        }
      );
    }
  }
  postverifypassword() {
    console.log(
      "verifyPasswordFromControl.confirmPassword.errors",
      this.verifyPasswordFromControl.confirmPassword.errors
    );
    if (this.verifyPasswordFrom.invalid) {
      console.log("Verify Password false");
      return false;
    } else {
      this.loginService
        .changeForgetPassword(this.verifyPasswordFrom.value)
        .then(
          (res) => {
            this.toastService.toastMsg({
              title: "Success",
              content: "Password Changed Successfully!",
            });
            // this.toastService.openSnackBar("Password Changed Successfully");
            this.router.navigate(["/auth/role-selection"]);
          },
          (err) => {
            if (err.error.expose) {
              this.toastService.toastMsg({
                title: "Error",
                content: this.titleCasePipe.transform(err.error.error_message),
              });
              // this.toastService.openErrorSnackBar(
              //   this.titleCasePipe.transform(err.error.error_message)
              // );
            } else {
              this.toastService.toastMsg({
                title: "Error",
                content: "Something Went Wrong",
              });
              // this.toastService.openErrorSnackBar("Something Went Wrong.");
            }
          }
        );
    }
  }
}
